<template>
  <div class="site_item" @click="onSite">
    <div class="item_header">
      <b-img :src="images.length > 0 ? images[0].replace(new RegExp(/\\/g), '/') : IMAGE_FOO_URL"
             class="site_img"/>
      <div class="site_name img-center"
           :style="images.length > 0 ? 'color:white':'color:black;text-shadow:none'">{{item.f_name}}</div>
      <div v-if="item.f_supply_meal === 'Y'" class="badge_tail badge_finish" />
      <div v-if="item.f_supply_meal === 'Y'" class="badge">
         <span class="badge_text">{{$t('site_detail.meal')}}</span>
      </div>
    </div>
    <div class="item_body">
      <div style="width: 85px;">
        <span class="open_wrapper open_date_label">{{$t('home.open_date')}}</span>
        <span class="open_date">{{moment(item.f_open_date).format('MM. DD')}}</span>
      </div>
      <div style="padding-top: 3px;width: 127px;">
        
<!--        <span class="site_address">{{'ss'}}</span>-->   
        <span class="site_address">{{utils.getAddress(item)}}</span>           
        <b-img :src="require('../../assets/image/ic_address_detail@2x.png')" style="margin-left: 5px; height: 1em; vertical-align: text-bottom;float: right;margin-top: 2px;"/>
      </div>

    </div>
    <SiteDetail v-if="siteDetailData != null" :visible.sync="showSiteDetailPopup" :site="siteDetailData" />
  </div>
</template>

<script>
import Constant from "../../config/constant";
import moment from "moment";
import utils from "../../config/utils";
import Utils from "../../config/utils";
import SiteDetail from "../contents/main/interest/SiteDetail";
export default {
  name: "SiteSimpleItem",
  components: {
    SiteDetail,
  },
  data(){
    return {
      images : [],
      IMAGE_FOO_URL: Constant.IMAGE_FOO_URL,
      utils:utils,
      moment:moment,
      showSiteDetailPopup:false,
      siteDetailData:null,
    }
  },
  props:{
    item:{
      type: Object,
      default: null,
    },
  },
  inject: ["eventBus"],
  methods:{
    onSite(){
      this.eventBus.$emit("checkTicketAvailable", ()=>{
        this.go2SiteDetail(this.item.f_idx);
      });
    },
    go2SiteDetail(siteIdx){
      Utils.requestGet(
        this.$c.API.Site.getSiteDetail,
        {
          site_idx: siteIdx,
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.siteDetailData = result.data;
          this.showSiteDetailPopup = true;
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
  },
  mounted() {
    this.images = (this.item.f_image_urls == null)
      ? []
      : this.item.f_image_urls.split(',').filter((it) => {
        return it != '';
      });
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/vars";
.site_item{
  width: 210px;
  //height: 207px;
  overflow: hidden;
  margin-bottom: 1em;
}
.site_item:nth-child(odd){
  margin-right: 0.4em;
}
.site_item:nth-child(even){
  margin-left: 0.4em;
}
.img-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.item_header{position:relative;width: 100%; height: 140px; border-radius: 5px; overflow: hidden; border: 1px solid #267fff4f;};
.site_img{width: 100%; height: 100%};
.site_name{width:100%; color: $white; font-size: $fs_22; font-family: $korean_gd_16_r; display: flex; align-items: center;justify-content: center; text-shadow: -0.5px 0 #000, 0 0.5px #000, 0.5px 0 #000, 0 -0.5px #000;};
.open_wrapper{
  background-color: #cf0000;
  margin-right: 3px;
  width: 28px;
  height: 17.7px;
  border-radius: 1.6px;
};
.open_date_label{color: $white; font-size: $fs_14; font-family: $korean_gd_17_r; padding: 5px;};
.open_date{color: #cf0000; font-size: $fs_15; font-family: $korean_gd_17_r};
.site_address{
  color: #0660e2;
  font-size: $fs_14;
  font-family: $korean_gd_17_r;
  margin-left: 3px;
  overflow: hidden;
  white-space: nowrap;
  float: right;
};
.item_body{
  margin-top: 6px; 
  //justify-content: space-between; 
  display: flex; 
  flex-direction: row;
  };

.badge {
  position: absolute !important;
  top: 8px;
  right: 0;
  padding-right: 3px;

  /** Rotation */
  -webkit-transform: rotate(40deg); 
  -moz-transform: rotate(40deg);    
  transform:rotate(40deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
}

.badge_text {
  color: $white;
  font-size: 20px;
  font-family: $korean_gd_13_r;
  margin-top: 4px;
  margin-right: 2px;
}

.badge_finish {
  border-top-color: $yellow_bg;
}

.badge_tail {
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  background-color: transparent;
  border-style: solid;
  border-left-width: 70px;
  border-right-width: 0;
  border-top-width: 65px;
  border-bottom-width: 0;
  border-left-color: transparent;
  border-right-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/SiteSimpleItem.vue